export default __webpack_public_path__ + "static/media/Avatar-3.7c7c42ba.png";